import queryString from 'query-string';
import { useMemo } from 'react';
import { DateTime } from 'luxon';

import {
  defaultLodgingAdults,
  defaultLodgingRooms,
  defaultSkiRentalAdults,
  defaultSkiRentalChildren,
} from 'components/common/PlanYourTrip/constants';

export const getLodgingFromQuery = () => {
  const parsed = queryString.parse(global?.location?.search ?? '');
  const {
    from, to, adult, rms,
  } = parsed;

  const data = useMemo(() => {
    const now = (DateTime.now().startOf('day'));
    const initialFromDate = now.plus({ days: 14 });
    const initialToDate = initialFromDate.plus({ days: 3 });

    /**
     * Take valid date that is at min on today
     */
    const parsedFrom = from ? DateTime.fromISO(from.toString()) : initialFromDate;
    const checkInReq = parsedFrom.isValid ? parsedFrom : initialFromDate;
    const checkIn = checkInReq.diff(now).milliseconds >= 0 ? checkInReq : initialFromDate;

    /**
     * Take valid date that is at min on checkIn + 1
     */
    const parsedTo = to ? DateTime.fromISO(to.toString()) : initialToDate;
    const checkOutReq = parsedTo.isValid ? parsedTo : initialToDate;
    const checkOut = checkOutReq.diff(checkIn).as('days') >= 1 ? checkOutReq : checkIn.plus({ day: 1 });

    const parsedAdults = +(adult || defaultLodgingAdults);
    const parsedRooms = +(rms || defaultLodgingRooms);
    // eslint-disable-next-line no-restricted-globals
    const numAdults = isNaN(parsedAdults) ? defaultLodgingAdults : parsedAdults;
    // eslint-disable-next-line no-restricted-globals
    const numRooms = isNaN(parsedRooms) ? defaultLodgingRooms : parsedRooms;
    return {
      checkIn,
      checkOut,
      numAdults,
      numRooms,
    };
  }, [from || '', to || '', adult || defaultLodgingAdults, rms || defaultLodgingRooms]);

  return data;
};
export const getSkiRentalFromQuery = () => {
  const parsed = queryString.parse(global?.location?.search ?? '');
  const {
    from, to, adult, kid,
  } = parsed;

  const data = useMemo(() => {
    const now = (DateTime.now().startOf('day'));
    const closestThursday = (DateTime.now().startOf('week').set({ weekday: 4 }));
    const nextThursday = closestThursday.plus({ week: 1 });
    const nextSunday = nextThursday.plus({ day: 3 });

    /**
     * Take valid date that is at min on today
     */
    const parsedFrom = from ? DateTime.fromISO(from.toString()) : nextThursday;
    const checkInReq = parsedFrom.isValid ? parsedFrom : nextThursday;
    const checkIn = checkInReq.diff(now).milliseconds >= 0 ? checkInReq : nextThursday;

    /**
     * Take valid date that is at min on checkIn + 1
     */
    const parsedTo = to ? DateTime.fromISO(to.toString()) : nextSunday;
    const checkOutReq = parsedTo.isValid ? parsedTo : nextSunday;
    const checkOut = checkOutReq.diff(checkIn).as('days') >= 1 ? checkOutReq : checkIn.plus({ day: 1 });

    const parsedAdults = +(adult || defaultSkiRentalAdults);
    const parsedChildren = +(kid || defaultSkiRentalChildren);
    // eslint-disable-next-line no-restricted-globals
    const numAdults = isNaN(parsedAdults) ? defaultSkiRentalAdults : parsedAdults;
    // eslint-disable-next-line no-restricted-globals
    const numChildren = isNaN(parsedChildren) ? defaultSkiRentalChildren : parsedChildren;
    return {
      checkIn,
      checkOut,
      numAdults,
      numChildren,
    };
  }, [from || '', to || '', adult || defaultSkiRentalAdults, kid || defaultSkiRentalChildren]);

  return data;
};
